import { render, staticRenderFns } from "./DiagramNode.vue?vue&type=template&id=b1e5f6d2&scoped=true&"
import script from "./DiagramNode.vue?vue&type=script&lang=js&"
export * from "./DiagramNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e5f6d2",
  null
  
)

export default component.exports